import {
  BREADCRUMBS_HEIGHT,
  HEADER_HEIGHT,
  PROGRESS_BAR_HEIGHT,
} from 'app/constants'

class LayoutService {
  getAppContainerHeight = (startHeight: string) =>
    `calc(${startHeight} - ${HEADER_HEIGHT} - ${PROGRESS_BAR_HEIGHT})`
  getMainContainerHeight = (startHeight: string) =>
    `calc(${startHeight} - ${HEADER_HEIGHT} - ${PROGRESS_BAR_HEIGHT})`
  getProductsContainerHeight = ({ startHeight }: { startHeight: string }) =>
    `calc(${startHeight} - ${HEADER_HEIGHT} - ${BREADCRUMBS_HEIGHT} - ${PROGRESS_BAR_HEIGHT})`
  getInfoDrawerHeight = (startHeight: string, operator: string) =>
    `calc(${startHeight} ${operator} ${HEADER_HEIGHT} ${operator} ${BREADCRUMBS_HEIGHT} ${operator} ${PROGRESS_BAR_HEIGHT})`
}

export const layoutService = new LayoutService()
